import React, { useState } from 'react';
import Dialog, { DialogFooter, DialogHeader } from '../../../bootstrap/Dialog.jsx';
import Button from '../../../bootstrap/Button.jsx';
import Portal from '../../../common/Portal.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { arraysHaveSameElements } from '../../DashboardGridIndex.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { saveWidgetSettingsWithId } from '../../redux/dashboardSlice.js';
import { FaIcon } from '../../../common/Icons.jsx';
import styles from '../base/CommonSettings.module.scss';
import CKEditor5 from '../../../ckeditor5/Editor.lazy.jsx';
import ToggleableSection from '../../settings_sidebar/common/ToggleableSection.jsx';

function EditorDialog({...props}) {
  return (
    <Dialog {...props}>
      <CKEditor5 {...props} />
    </Dialog>
  )
}

function PageEditorWidgetSettings({ widgetId }) {
  const dispatch = useDispatch();
  const setAttribute = useSetWidgetAttribute(widgetId);
  const accessible_publicly = useSelector(state => state.dashboard.widgets[widgetId].accessible_publicly)
  const projectId = useSelector(state => state.dashboard.projectId);
  const attachments = useSelector(state => state.dashboard.widgets[widgetId].settings?.attachments, arraysHaveSameElements) || [];
  const pageHTML = useSelector(state => state.dashboard.widgets[widgetId].settings?.html) || '';
  const placeholder = useSelector(state => state.dashboard.widgets[widgetId].settings?.placeholder) || {html: ''};
  const [editMode, setEditMode] = useState(false);
  const [editPlaceholder, setEditPlaceholder] = useState(false);
  const permissionCode = accessible_publicly ? 'public_dashboard.show' : 'dashboard.show'; 
  const permissions = {
      [permissionCode] : {
          id: projectId,
          type: 'project'
      }
  }
  
  const closeDialog = () => {setEditMode(false)};
  const showDialog = () => {setEditMode(true)};
  const updateHtml = (val) => {setAttribute('settings.html', val)}

  const closePlaceholder = () => {setEditPlaceholder(false)};
  const openPlaceholder = () => {setEditPlaceholder(true)};
  const updatePlaceholder = (val) => {setAttribute('settings.placeholder.html', val)};

  const saveSettings = () => {
      dispatch(saveWidgetSettingsWithId({widgetId}));
      setEditMode(false);
      setEditPlaceholder(false);
  }

  const addAttachmentToSettings = (res) => {
      const attachmentId = res.attachment_id;
      if (!attachmentId) return;
      setAttribute('settings.attachments', [...attachments, attachmentId])
  }

  return (
    <>
      {editMode && 
        <Portal
          component={EditorDialog}
          className='page-editor-widget-dialog'
          /* Dialog props */
          header={<DialogHeader showBorder={true} title={I18n.t('edit_page')} onClose={closeDialog} />}
          footer={<DialogFooter addText={I18n.t('save')} onAdd={saveSettings} onClose={closeDialog} />}
          style={editMode ? {display:'block'} : {display:'none'}}
          size='xl'
          closeOnOutsideClick={true}
          /* CKEditor props */
          disableTitle={true}
          initialHtml={pageHTML}
          updateHtml={updateHtml}
          permissions={permissions}
          callback={addAttachmentToSettings}
        />}
      {editPlaceholder &&
        <Portal
          component={EditorDialog}
          className='page-editor-widget-dialog'
          /* Dialog props */
          header={<DialogHeader showBorder={true} title={I18n.t('edit_placeholder_content')} onClose={closePlaceholder} />}
          footer={<DialogFooter addText={I18n.t('save')} onAdd={saveSettings} onClose={closePlaceholder} />}
          style={editPlaceholder ? {display:'block'} : {display:'none'}}
          size='xl'
          closeOnOutsideClick={true}
          /* CKEditor props */
          disableTitle={true}
          initialHtml={placeholder.html}
          updateHtml={updatePlaceholder}
          permissions={permissions}
          callback={addAttachmentToSettings}
        />}
      <hr />
      <div className={styles['settings-option']}>
        <h4>{I18n.t('edit_page')}</h4>
        <Button onClick={showDialog}>
            <FaIcon type='pencil' />{I18n.t('edit')}
        </Button>
      </div>
      <hr />
      <ToggleableSection title={I18n.t('placeholder_content')} selectedObject={{placeholder}} setAttribute={(path, val) => setAttribute(`settings.${path}`, val)}
        prefix='placeholder' enabledKey={'enabled'} initialCollapsed={false} >
        <div className={styles['settings-option']}>
          <Button onClick={openPlaceholder}>
              <FaIcon type='pencil' />{I18n.t('edit')}
          </Button>
          <p className='description'>{I18n.t('page_editor_placeholder_content_description')}</p>
        </div>
      </ToggleableSection>
    </>
  )
}

export default PageEditorWidgetSettings;